import { Link } from "react-router-dom";

export const PageHead = ({ crumbs, title, lede, children }) => (
  <div className="border-b border-line bg-surface">
    <div className="mx-auto w-full max-w-[1200px] px-4 py-12 sm:px-6 md:py-16 lg:px-8">
      <nav className="am-eyebrow flex flex-wrap items-center gap-2 text-mute" aria-label="Breadcrumb">
        {crumbs.map((c, i) => (
          <span key={i} className="flex items-center gap-2">
            {i > 0 && <span aria-hidden="true">›</span>}
            {c.to ? (
              <Link className="transition-colors hover:text-ink" to={c.to}>
                {c.label}
              </Link>
            ) : (
              <span className="text-ink">{c.label}</span>
            )}
          </span>
        ))}
      </nav>
      <h1 className="mt-4 max-w-3xl font-display text-4xl font-extrabold text-ink sm:text-5xl" data-testid="page-title">
        {title}
      </h1>
      {lede && <p className="mt-4 max-w-2xl text-base leading-relaxed text-mute">{lede}</p>}
      {children}
    </div>
  </div>
);
